import { render, staticRenderFns } from "./SendDoc.vue?vue&type=template&id=482d2f26&"
import script from "./SendDoc.vue?vue&type=script&lang=js&"
export * from "./SendDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports